var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container-home"},[_c('board-detail-component',{attrs:{"boardType":`performDetail`,"boardKey":_vm.boardKey}})],1),_c('page-footer',{attrs:{"hasBack":true,"performKey":_vm.performKey}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }